// extracted by mini-css-extract-plugin
module.exports = {"row":"cardLayout-module--row--IeEZy","imageColumn":"cardLayout-module--imageColumn--3Zo9N","headerImage":"cardLayout-module--headerImage--3G_NT"};